export default __webpack_public_path__ + "static/media/spark_81.7cb1b616.png";